const ReposActionTypes = {
    FETCH_ALL_REPOS: "FETCH_ALL_REPOS", 
    FETCH_SELECTED_REPO: "FETCH_SELECTED_REPO"
};

export default ReposActionTypes;